
import { GetBaseUrl } from "@/utils/ConfigHelper"
import Response from "@/utils/Videomonster/Common/Response"
import axios from "axios"
import { PUBLIC_ERROR_CODE } from '@/utils/Error/Constants'
import { GetPublicErrorCode } from '@/utils/Error/Handler'
import { fileUtils } from "@/utils/AiTool";

/**
 * @param {string} token 
 * @param {{
 *  query: string
 *  offset: number
 *  limit: number
 * }} data
 * @returns {Promise<Response>} 
 * @throws {Error}
 */
const GetGettyImagesVideos = async (token, data = {}) => {
    try{    
        const url = `${GetBaseUrl()}/apis/provider/gettyimages/videos?query=${data.query}&offset=${data.offset}&limit=${data.limit}`
        const config={ headers: { Authorization: `Bearer ${token}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result,resultData)
    }catch(e){
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param {string} token 
 * @param {{
 *  id: string
 * }} data
 * @returns {Promise<Response>} 
 * @throws {Error}
 */
const GetGettyImagesVideosDownloadLink = async (token, data = {}) => {
    try{    
        let { id, useCredit } = data

        // TO-DO : 로그 삭제
        // console.log(`GetGettyImagesVideosDownloadLink : ${id}`, '1813185507')
        // id = '1813185507'

        const url = `${GetBaseUrl()}/apis/provider/gettyimages/videos/${id}/download-link?use_credit=${useCredit}`
        const config={ headers: { Authorization: `Bearer ${token}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result,resultData)
    }catch(e){
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param {string} token 
 * @param {{
 *  query: string
 *  offset: number
 * }} data
 * @returns {Promise<Response>} 
 * @throws {Error}
 */
const GetGettyImagesImages = async (token, data = {}) => {
    try{    
        const url = `${GetBaseUrl()}/apis/provider/gettyimages/images?query=${data.query}&offset=${data.offset}`
        const config={ headers: { Authorization: `Bearer ${token}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result,resultData)
    }catch(e){
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param {string} token 
 * @param {{
 *  id: string
 *  useCredit: boolean
 * }} data
 * @returns {Promise<Response>} 
 * @throws {Error}
 */
const GetGettyImagesImagesDownloadLink = async (token, data = {}) => {
    try{    
        let { id, useCredit } = data

        // TO-DO : 로그 삭제
        // console.log(`GetGettyImagesImagesDownloadLink : ${id}`, 'jv13814161')
        // id = 'jv13814161'

        const url = `${GetBaseUrl()}/apis/provider/gettyimages/images/${id}/download-link?use_credit=${useCredit}`
        const config={ headers: { Authorization: `Bearer ${token}` } }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result,resultData)
    }catch(e){
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param {string} token 
 * @param {{
 *  id: string
 * }} data
 * @returns {Promise<Response>} 
 * @throws {Error}
 */
const GetGettyImagesImagesDirectDownloadToBase64 = async (token, data = {}) => {
    try{
        let { id, useCredit } = data;

        // TO-DO : 로그 삭제
        // console.log(`GetGettyImagesImagesDirectDownload : ${id}`, 'jv13814161')
        // id = 'jv13814161'

        const url = `${GetBaseUrl()}/apis/provider/gettyimages/images/${id}/direct-download?use_credit=${useCredit}`
        const config = { 
            headers: { Authorization: `Bearer ${token}` },
            responseType: 'arraybuffer'
        }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const base64 = `data:image/jpg;base64,${fileUtils.ArrayBufferToBase64(response.data)}`

        return new Response(result, base64)
    }
    catch(e){
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

const GetGettyImagesImagesDirectDownload = async (token, data = {}) => {
    try{
        let { id, useCredit } = data;

        // TO-DO : 로그 삭제
        // id = 'jv13814161'
        // console.log(`GetGettyImagesImagesDirectDownloadToObjectURL : ${id}`)
        
        const url = `${GetBaseUrl()}/apis/provider/gettyimages/images/${id}/direct-download?use_credit=${useCredit}`
        const config = { 
            headers: { Authorization: `Bearer ${token}` },
            responseType: 'blob'
        }
        const response = await axios.get(url, config)
        const result = (response.status === 200)
        const resultData = response.data

        return new Response(result, resultData)
    }
    catch(e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

export default {
    GetGettyImagesVideos,
    GetGettyImagesVideosDownloadLink,
    GetGettyImagesImages,
    GetGettyImagesImagesDownloadLink,
    GetGettyImagesImagesDirectDownloadToBase64,
    GetGettyImagesImagesDirectDownload,
}